import { mainPath } from "../../lib/mainPath";
import { requestsTemplates } from "../../lib/requestsTemplates";

export const remove = (id) =>requestsTemplates.remove(mainPath, `/employee/custom/${id}`);
